import { Config } from "@js-from-routes/client";

const originalOnResponseError = Config.onResponseError.bind(Config);

/**
 * Redirect to sign-in on 401 so an expired session doesn't leave the user
 * staring at a generic "Something went wrong" error.
 *
 * @param {Error} error
 */
Config.onResponseError = (error) => {
  if (error?.response?.status === 401) {
    window.location.href = "/sign_in";
    return;
  }
  return originalOnResponseError(error);
};
